import { render, staticRenderFns } from "./GroupForMaintenance.vue?vue&type=template&id=907ba61c"
import script from "./GroupForMaintenance.vue?vue&type=script&lang=ts"
export * from "./GroupForMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports